const _cfg = (typeof window !== 'undefined' && window.TXSHIELD_CONFIG) || {};

// String fields
const TXSHIELD_SECURE_BASE_URL = _cfg.TXSHIELD_SECURE_BASE_URL || '';
const API                      = _cfg.API                      || '';
const API_TX                   = _cfg.API_TX                   || '';
const API_TXALERT              = _cfg.API_TXALERT              || '';
const API_TXFRAUD              = _cfg.API_TXFRAUD              || '';
const API_MERCHANT             = _cfg.API_MERCHANT             || '';
const API_RETAILER             = _cfg.API_RETAILER             || '';
const API_SITE                 = _cfg.API_SITE                 || '';
const API_DATA_SOURCE          = _cfg.API_DATA_SOURCE          || '';
const API_BASE_URL             = _cfg.API_BASE_URL             || '';
const API_DOMAIN_MONITOR       = _cfg.API_DOMAIN_MONITOR       || '';
const OI_URL                   = _cfg.OI_URL                   || '';
const CBM_URL                  = _cfg.CBM_URL                  || '';
const THREEDS_URL              = _cfg.THREEDS_URL              || '';
const API_TXALERT2             = _cfg.API_TXALERT2             || '';
const WHITELABEL_DISPLAY_NAME          = _cfg.WHITELABEL_DISPLAY_NAME  || '';
const THEME                            = _cfg.THEME                    || 'default';
const SESSION_TIMEOUT         = _cfg.SESSION_TIMEOUT !== undefined ? Number(_cfg.SESSION_TIMEOUT) : 15;

// Boolean fields — defaults mirror safe production values
// _cfg.X !== false  means: true unless explicitly set to false (default-true flags)
// _cfg.X === true   means: false unless explicitly set to true (default-false flags)
const DEV_MODE                         = _cfg.DEV_MODE                         === true;
const DISABLE_OI                       = _cfg.DISABLE_OI                       === true;
const DISABLE_CBM                      = _cfg.DISABLE_CBM                      !== false; // default true
const DISABLE_ALERTS                   = _cfg.DISABLE_ALERTS                   === true;
const DISABLE_THREEDS_MICROSERVICE     = _cfg.DISABLE_THREEDS_MICROSERVICE     === true;
const DISABLE_PAYMENTS                 = _cfg.DISABLE_PAYMENTS                 === true;
const DISABLE_MATCH_REFUND             = _cfg.DISABLE_MATCH_REFUND             === true;
const DISABLE_TXALERT2                 = _cfg.DISABLE_TXALERT2                 !== false; // default true
const DISPLAY_PAYMENT_LINK             = _cfg.DISPLAY_PAYMENT_LINK             === true;
const DISPLAY_USER_MESSAGES            = _cfg.DISPLAY_USER_MESSAGES            !== false; // default true
const DISABLE_CHARGEBACKS              = _cfg.DISABLE_CHARGEBACKS              !== false; // default true
const ENABLE_BATCH_ALERT_STATUS_UPDATE = _cfg.ENABLE_BATCH_ALERT_STATUS_UPDATE === true;
const DISABLE_DOMAIN_MONITOR           = _cfg.DISABLE_DOMAIN_MONITOR           === true;
const DISABLE_ALERT_REPORTING_SECTION  = _cfg.DISABLE_ALERT_REPORTING_SECTION  === true;
const DISPLAY_TEST_ENV_WARNING          = _cfg.DISPLAY_TEST_ENV_WARNING          === true;

module.exports = {
    TXSHIELD_SECURE_BASE_URL, API, API_TX, API_TXALERT, API_TXFRAUD,
    API_MERCHANT, API_RETAILER, API_SITE, API_DATA_SOURCE, API_BASE_URL,
    API_DOMAIN_MONITOR, OI_URL, CBM_URL, THREEDS_URL, API_TXALERT2,
    WHITELABEL_DISPLAY_NAME, THEME, SESSION_TIMEOUT,
    DEV_MODE, DISABLE_OI, DISABLE_CBM, DISABLE_ALERTS, DISABLE_THREEDS_MICROSERVICE,
    DISABLE_PAYMENTS, DISABLE_MATCH_REFUND, DISABLE_TXALERT2, DISPLAY_PAYMENT_LINK,
    DISPLAY_USER_MESSAGES, DISABLE_CHARGEBACKS, ENABLE_BATCH_ALERT_STATUS_UPDATE,
    DISABLE_DOMAIN_MONITOR, DISABLE_ALERT_REPORTING_SECTION, DISPLAY_TEST_ENV_WARNING
};
